/// <reference types="@types/jquery" />
$ = jQuery
console.log('>>>???')
function isInViewport(el: HTMLElement) {
	const rect = el.getBoundingClientRect()

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	)
}

async function playVideo(el: HTMLVideoElement) {
	if (el) {
		try {
			await el.play()
		} catch (err) {
			console.log(err)
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const videoElem = document.querySelector<HTMLVideoElement>('#video')
	let once = false

	if (videoElem) {
		$(window).on('scroll', () => {
			if (isInViewport(videoElem)) {
				if (!once) {
					once = true
					playVideo(videoElem)
				}
			}
		})

		const muteButton = $('.mute-button')
		muteButton.on('click', () => {
			muteButton.toggleClass('active')
			videoElem.muted = !videoElem.muted
		})
	}
})
